import React from 'react';

import Auth from 'Components/Layouts/Auth';
import {Networking} from 'Components/Networking';

import { asset } from 'Services/BaseHelpers';

export default class NetworkingIndex extends React.Component {
    header = () => (
        <div className="h-banner bg-banner-networking bg-no-repeat bg-cover bg-right relative">
            <div className="absolute h-full w-full flex">
                <span className="m-auto text-app-green-banner text-4xl font-gilroy">Networking</span>
            </div>
            <img
                alt=""
                src={asset("/images/pages/networking/left.svg")}
                className="max-h-banner hidden md:block h-full px-2 md:px-4 lg:px-6  py-5 lg:mt-0"
            />
        </div>
    );


    /**
     * @method render
     * @return {*}
     */
    render() {
        return (
            <Auth
                customHeader={this.header()}
                containerWidth="max-w-8xl w-full flex-1 flex flex-col h-full"
                contentClass="w-full bg-app-gray flex-1 flex flex-col w-full -mt-5"
            >
                <div className="h-full w-full flex-1 flex flex-col text-black">
                    <Networking
                        displayUsers={true}
                        displayChats={true}
                        displayChat={true}
                        fullScreen={true}
                        useGroups={false}
                        selectedMessageToType='App\Models\User'
                        selectedMessageToId={this.props.match?.params?.user}
                    />
                </div>
            </Auth>
        )
    }
}
